define('plugin/category/view/CategoryStepView',['require','lib/view/CompositeView','plugin/category/view/CategoryItemView','plugin/category/view/CategoryEmptyView'],function (require) {

	var CompositeView = require('lib/view/CompositeView');
	var CategoryItemView = require('plugin/category/view/CategoryItemView');
	var CategoryEmptyView = require('plugin/category/view/CategoryEmptyView');

	/**
	 * Category composite view (categorys container)
	 * 
	 * @class CategoryStepView
	 */
	return CompositeView.extend({
	
	    template: '#category_step',
	    childView: CategoryItemView,
	    childViewContainer: '#sb_category_step_container',
        
        emptyView: CategoryEmptyView,
        isEmpty: function (collection) {
            return collection._once_synced ? collection.isEmpty() : false;
        },

		_pageId: 'booking_category'
	    
	});
	
});
